export default __webpack_public_path__ + "static/media/cert-finance-cpttm.64c43db4.jpg";